import LAmap1 from './src/main'

/* istanbul ignore next */
LAmap1.install = function(Vue) {
  Vue.component(LAmap1.name, LAmap1)
}

export default LAmap1
